const SHIFT_DURATION_MS = 8 * 60 * 60 * 1000;
export const OVERTIME_REMARKS_THRESHOLD_MS = 1 * 60 * 60 * 1000;
const SHIFT_START_HOUR_BY_KEY = { morning: 6, afternoon: 14, night: 22 };
export const SHIFT_OPTIONS = [
  { value: 'morning', label: 'Morning (06:00-15:00)' },
  { value: 'afternoon', label: 'Afternoon (14:00-23:00)' },
  { value: 'night', label: 'Night (22:00-07:00)' },
];

export const formatTime = (value) =>
  value ? new Date(value).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—';

export const formatAbsenceType = (value) => {
  if (value === 'sick-leave') return 'Sick leave';
  if (value === 'vacation') return 'Vacation';
  return 'Absent';
};

export const calculateWorkedMs = (checkInTime, checkOutTime) => {
  if (!checkInTime || !checkOutTime) return 0;
  const checkInMs = new Date(checkInTime).getTime();
  const checkOutMs = new Date(checkOutTime).getTime();
  if (Number.isNaN(checkInMs) || Number.isNaN(checkOutMs)) return 0;
  return Math.max(0, checkOutMs - checkInMs);
};

export const normalizeAssignedShift = (value) => {
  if (value === null || value === undefined) return null;
  const raw = String(value).trim().toLowerCase();
  if (!raw) return null;
  if (raw === '1' || raw === 'morning' || raw === 'shift1' || raw === 'shift-1') return 'morning';
  if (raw === '2' || raw === 'afternoon' || raw === 'shift2' || raw === 'shift-2') return 'afternoon';
  if (raw === '3' || raw === 'night' || raw === 'shift3' || raw === 'shift-3') return 'night';
  return null;
};

export const inferAssignedShift = (checkInTime) => {
  const checkIn = new Date(checkInTime);
  if (Number.isNaN(checkIn.getTime())) return null;
  const hourWithMinutes = checkIn.getHours() + checkIn.getMinutes() / 60;
  if (hourWithMinutes >= 6 && hourWithMinutes < 14) return 'morning';
  if (hourWithMinutes >= 14 && hourWithMinutes < 22) return 'afternoon';
  return 'night';
};

const getShiftStart = (checkInTime, assignedShift) => {
  if (!checkInTime) return null;
  const checkIn = new Date(checkInTime);
  if (Number.isNaN(checkIn.getTime())) return null;
  const resolvedShift = inferAssignedShift(checkIn) || normalizeAssignedShift(assignedShift);
  if (!resolvedShift) return null;
  const shiftStart = new Date(checkIn);
  shiftStart.setMinutes(0, 0, 0);
  if (resolvedShift === 'night') {
    if (checkIn.getHours() < 7) shiftStart.setDate(shiftStart.getDate() - 1);
    shiftStart.setHours(SHIFT_START_HOUR_BY_KEY.night, 0, 0, 0);
    return shiftStart;
  }
  shiftStart.setHours(SHIFT_START_HOUR_BY_KEY[resolvedShift], 0, 0, 0);
  return shiftStart;
};

export const calculateOvertimeMs = (checkInTime, checkOutTime, assignedShift) => {
  if (!checkInTime || !checkOutTime) return 0;
  const checkIn = new Date(checkInTime);
  const checkOut = new Date(checkOutTime);
  if (Number.isNaN(checkIn.getTime()) || Number.isNaN(checkOut.getTime())) return 0;
  const shiftStart = getShiftStart(checkInTime, assignedShift);
  if (!shiftStart) return 0;
  const effectiveStartMs = Math.max(shiftStart.getTime(), checkIn.getTime());
  return Math.max(0, checkOut.getTime() - (effectiveStartMs + SHIFT_DURATION_MS));
};

export const formatDuration = (milliseconds) => {
  if (!milliseconds || milliseconds <= 0) return '0m';
  const totalMinutes = Math.floor(milliseconds / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (!hours) return `${minutes}m`;
  return `${hours}h ${minutes}m`;
};

export const formatReadableSystemRemark = (value) => {
  const remark = String(value || '');
  const match = remark.match(/System auto-checkout applied at\s+([^\s]+)\s+after grace window\./i);
  if (!match) return remark;
  const parsed = new Date(match[1]);
  if (Number.isNaN(parsed.getTime())) return remark;
  const pretty = parsed.toLocaleString('en-GB', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  });
  return remark.replace(match[1], pretty);
};
